import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';

@Component({
  selector: 'lc-footer-bar',
  templateUrl: './footer-bar.component.html',
  styleUrls: ['./footer-bar.component.scss']
})
export class FooterBarComponent implements OnInit {

  private social_links = [
  	{
  		title: 'twitter',
  		icon: 'ion-social-twitter',
  		url: 'https://twitter.com/philipsnl'
  	},
	  {
  		title: 'facebook',
  		icon: 'ion-social-facebook',
  		url: 'https://www.facebook.com/PhilipsNederland/'
  	},
  	// {
  	// 	title: 'linkedin',
  	// 	icon: 'ion-social-linkedin',
  	// 	url: 'http://www.linkedin.com/company/Philips-Nederland'
  	// },
  	{
  		title: 'instagram',
  		icon: 'ion-social-instagram',
  		url: 'https://instagram.com/philipsbenelux/'
  	},
  	{
  		title: 'pinterest',
  		icon: 'ion-social-pinterest',
  		url: 'https://nl.pinterest.com/philipsbenelux/'
  	},
  	{
  		title: 'youtube',
  		icon: 'ion-social-youtube',
  		url: 'https://www.youtube.com/channel/UCiClJzd0G861i04l00ihxkA'
  	}
  ];

  private social_links_EN = [
  	{
  		title: 'twitter',
  		icon: 'ion-social-twitter',
  		url: 'http://www.twitter.com/Philips'
  	},
	  {
  		title: 'facebook',
  		icon: 'ion-social-facebook',
  		url: 'http://www.facebook.com/Philips'
  	},
  	// {
  	// 	title: 'linkedin',
  	// 	icon: 'ion-social-linkedin',
  	// 	url: 'http://www.linkedin.com/company/Philips-Nederland'
  	// },
  	{
  		title: 'instagram',
  		icon: 'ion-social-instagram',
  		url: 'https://www.instagram.com/philips/?hl=en'
  	},
  	{
  		title: 'pinterest',
  		icon: 'ion-social-pinterest',
  		url: 'http://www.pinterest.com/Philips/'
  	},
  	{
  		title: 'youtube',
  		icon: 'ion-social-youtube',
  		url: 'http://www.youtube.com/Philips'
  	}
  ];

  private footer_links = [
  	{
  	   	title: 'Investor Relations',
  	   	url: 'http://www.philips.nl/a-w/about-philips/financiele-informatie.html'
  	},
	{
      	title: 'Carrière',
      	url: 'http://www.careers.philips.com/nl_nl/index.wpd'
  	},
  	{
  		title: 'Contact opnemen met Philips',
  		url: 'mailto:sonicarezoom.benelux@philips.com'
  	},
  	{
  		title: 'Philips',
  		url: 'http://www.philips.nl/a-w/site-owner.html'
  	},
  	{
  		title: 'Gebruiksvoorwaarden',
  		url: 'http://www.philips.nl/a-w/gebruiksvoorwaarden.html'
  	},
  	// {
  	// 	title: 'Sitemap',
  	// 	url: 'http://www.sitemap.philips.com/sitemap/nl_nl/'
  	// },
    {
  		title: 'Privacyverklaring',
  		url: 'http://www.philips.nl/a-w/privacyverklaring.html'
  	}
  ];


  public date_today: Date = new Date();
  // public brand = 'PHILIPS';
  // private footer_links: any;

  constructor( public dataService: DataService ) {
    // if( window['brand'] ) this.brand = window['brand'];
  }

  ngOnInit() {
    const lng = this.dataService.current_language;
    if( lng == 'en' ) {
      this.social_links = this.social_links_EN;
    }
	if( !!this.dataService.CONTACT && !!this.dataService.CONTACT.email ){
		
		for(let l of this.footer_links){
			if(l.url.startsWith('mailto')){
				l.url = `mailto:${this.dataService.CONTACT.email}`;
			}
		}
	} 
  }

  track_social(socialservice){
    try{ window['track_event']({name:"follow_us", servicename: socialservice}) }catch(e){};
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/footer-bar/footer-bar.component.ts